import React from "react";
import Layout from "Components/Layouts/Common/common";
import AboutClasses from "./styles.module.css";
import About3 from "Assets/About/about_3.png";
import Image1 from "Assets/About/about_1.png";
import About_2 from "Assets/About/about_2.png";
import AboutCard from "Components/AboutUs/Cards/Cards";
function About() {
    return (
        <Layout>
            <div className={AboutClasses["Container"]}>
                <header>
                    <h3>Bookkeeping Services.</h3>
                </header>

                <div className={AboutClasses["section-1"]}>
                    <div className={AboutClasses["content"]}>
                        <h3>Accurate. Reliable. Tailored to Your Needs.</h3>
                        <p>
                            At <b>Serene Tax</b>,we understand that managing
                            your finances is one of the most critical aspects of
                            running a successful business. That’s why we offer
                            comprehensive bookkeeping services designed to help
                            you stay organized, compliant, and informed. Our
                            team ensures your financial records are accurate and
                            up-to-date, so you can focus on growing your
                            business with confidence.
                        </p>
                    </div>
                    <img src={Image1} alt="user" />
                </div>

                <div
                    className={`${AboutClasses["section-1"]} ${AboutClasses["section-2"]}`}>
                    <img src={About_2} alt="user" />
                    <div className={AboutClasses["content"]}>
                        {/* <h5>Who we are</h5>{" "} */}
                        <h3>Why Choose Serene Tax for Bookkeeping?</h3>
                        <p>
                            <b> Customized Solutions:</b> We tailor our
                            bookkeeping services to fit the specific needs of
                            your business, regardless of size or industry.
                        </p>
                        <p>
                            <b>Expert Team:</b> Our experienced professionals
                            are skilled in the latest bookkeeping methods and
                            software, ensuring accuracy and efficiency.
                        </p>
                        <p>
                            <b>Time-Saving:</b> By outsourcing your bookkeeping,
                            you save valuable time to focus on core business
                            operations.
                        </p>
                        <p>
                            <b>Compliance and Accuracy:</b> We ensure your
                            financial records comply with regulations and
                            provide a clear financial picture.
                        </p>
                    </div>
                </div>
                <div className={AboutClasses["section-1"]}>
                    <div
                        className={AboutClasses["content"]}
                        style={{ gap: "0.6rem" }}>
                        <h3>Our Bookkeeping Services Include:</h3>
                        <p>
                            <b>1.Recording Financial Transactions:</b>Failing to
                            We accurately record all financial transactions,
                            including sales, expenses, payments, and receipts,
                            ensuring your books are always up to date.
                        </p>
                        <p>
                            <b>2.Bank Reconciliation:</b>
                            We reconcile your bank statements with your
                            accounting records to identify discrepancies and
                            maintain accuracy.
                        </p>
                        <p>
                            <b>3.Accounts Payable and Receivable Management:</b>
                            We manage your invoices, payments, and collections
                            to ensure smooth cash flow.
                        </p>
                        <p>
                            <b>4.Expense Tracking:</b>Proper filings ensure your
                            business remains legally authorized to operate.
                        </p>
                        <p>
                            <b>5.Financial Reporting:</b>We provide detailed
                            financial reports, including profit and loss
                            statements, balance sheets, and cash flow analysis,
                            giving you insights into your business’s
                            performance.
                        </p>
                        <p>
                            <b>6.Payroll Integration:</b>
                            If needed, we integrate payroll data into your
                            bookkeeping system to streamline employee
                            compensation records.
                        </p>
                        <p>
                            <b>7.Tax-Ready Financials:</b>
                            Our bookkeeping services ensure your financial
                            records are organized and tax-ready, making tax
                            preparation seamless and hassle-free
                        </p>
                    </div>
                    <img src={About3} alt="user" />
                </div>
                <div
                    className={`${AboutClasses["section-1"]} ${AboutClasses["section-2"]}`}>
                    <img src={About3} alt="user" />
                    <div
                        className={AboutClasses["content"]}
                        style={{ gap: "0.6rem" }}>
                        <h3>Benefits of Professional Bookkeeping</h3>
                        <p>
                            <b>Improved Financial Insights:</b>
                            Gain a clear understanding of your business’s
                            financial health.
                        </p>
                        <p>
                            <b>Better Decision-Making:</b>
                            Make informed business decisions based on accurate
                            financial data.
                        </p>
                        <p>
                            <b>Time and Cost Efficiency:</b>
                            Avoid the costs and time associated with errors or
                            delayed financial reporting.
                        </p>
                        <p>
                            <b>Simplified Tax Filing:</b>
                            Organized financial records simplify the tax filing
                            process and help avoid penalties.
                        </p>
                    </div>
                </div>
                <div className={AboutClasses["section-1"]}>
                    <div
                        className={AboutClasses["content"]}
                        style={{ gap: "0.6rem" }}>
                        <h3>Industries We Serve</h3>
                        <h4>
                            Our bookkeeping services cater to a wide range of
                            industries, including:
                        </h4>
                        <ul>
                            <li>Small and Medium Businesses</li>
                            <li>Startups</li>
                            <li>Freelancers and Consultants</li>
                            <li>Retail and E-Commerce</li>
                            <li>Healthcare Providers</li>
                            <li>Nonprofits</li>
                            <li>Professional Services</li>
                        </ul>
                    </div>
                    <img src={About3} alt="user" />
                </div>
                <div
                    className={`${AboutClasses["section-1"]} ${AboutClasses["section-2"]}`}>
                    <img src={About3} alt="user" />
                    <div
                        className={AboutClasses["content"]}
                        style={{ gap: "0.6rem" }}>
                        <h3>Our Process</h3>
                        <p>
                            <b>1.Consultation:</b>
                            <br />
                            We begin by understanding your business needs and
                            current bookkeeping processes.
                        </p>
                        <p>
                            <b>2.Setup or Transition:</b>
                            <br />
                            Whether starting fresh or transitioning from an
                            existing system, we set up or migrate your financial
                            data seamlessly.
                        </p>
                        <p>
                            <b>3.Ongoing Maintenance:</b>
                            <br />
                            Our team manages your books regularly, providing
                            accurate and timely updates.
                        </p>
                        <p>
                            <b>4.Reporting and Communication:</b>
                            <br />
                            We deliver monthly or quarterly financial reports
                            and maintain clear communication to address your
                            concerns.
                        </p>
                    </div>
                </div>
                <div className={AboutClasses["section-1"]}>
                    <div
                        className={AboutClasses["content"]}
                        style={{ gap: "0.6rem" }}>
                        <h3>Why Serene Tax?</h3>
                        <p>
                            <b>Experienced Professionals:</b> With years of
                            experience, we deliver reliable and trustworthy
                            bookkeeping services.
                        </p>
                        <p>
                            <b>Latest Technology: </b>We use state-of-the-art
                            bookkeeping software to ensure accuracy and
                            efficiency.
                        </p>
                        <p>
                            <b>Custom Solutions:</b>
                            We tailor our services to your business’s unique
                            needs, whether you’re a small LLC or a multi-state
                            corporation.
                        </p>
                        <p>
                            <b>Transparent Pricing: </b>
                            Our pricing is competitive and transparent, with no
                            hidden fees.
                        </p>
                        <p>
                            <b>Commitment to Your Success:</b>We consider
                            ourselves partners in your success, working to help
                            your business thrive
                        </p>
                    </div>
                    <img src={About3} alt="user" />
                </div>

                <div
                    className={AboutClasses["section-1"]}
                    style={{ gridTemplateColumns: "1fr" }}>
                    <div
                        className={AboutClasses["content"]}
                        style={{ gap: "0.6rem" }}>
                        <h3>Ready to Simplify Your Bookkeeping?</h3>
                        <p>
                            Let <b>Serene Tax</b> handle your bookkeeping so you
                            can focus on what you do best—growing your business.
                            Contact us today to schedule a free consultation.
                            <br />
                            Contact us today for a consultation.{" "}
                            <b>Call [+1 (262) 735-8874/ +1 (262) 735- 8875]</b>
                        </p>
                    </div>
                </div>
            </div>
        </Layout>
    );
}

export default About;
